const quantities = [...document.querySelectorAll('.js-quantity')];

quantities.map(quantity => {
    const input = quantity.querySelector('.js-quantity-input');
    const select = quantity.querySelector('.js-quantity-select');

    if(input && select) {
        const changeHandler = () => {
            if(+select.value > 10) {
                select.remove();

                quantity.classList.remove('input--select');
                input.setAttribute('name', 'quantity');
                input.setAttribute('type', 'text');
                input.parentElement.classList.add('px-3');
                input.focus();
                input.setSelectionRange(input.value.length, input.value.length);
                input.setAttribute('type', 'number');
            }
        }

        changeHandler();
        select.addEventListener('change', changeHandler);
    }
});
